<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="add">新增任务</el-button>
      </div>
      <div>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.taskName"
          placeholder="请输入任务名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择任务开始时间筛选"
          end-placeholder="请选择任务结束时间筛选"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <!-- <el-button
          type="primary"
          size="small"
          @click="output('queryAllList', '活动任务')"
          :loading="isOutputing"
          >导出报表</el-button
        > -->
      </div>
    </div>
    <div class="flex flex-start mt20 mb10">
      <el-radio-group
        v-model="searchCondition.status"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="all">全部</el-radio-button>
        <el-radio-button label="ing">进行中({{ ingNum }})</el-radio-button>
        <el-radio-button label="out"> 已过期 ({{ outNum }})</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="taskName"
          label="任务名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="startDate"
          label="任务时间"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.model === 'manual' || scope.row.model === 'peoplePackage' || scope.row.model === 'tagGroup' ">
              {{ scope.row.startDate }}至{{ scope.row.endDate }}
            </div>
            <div v-else>
              每天
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalNum"
          label="任务总人数/联系人数/转化人数"
        >
        <template slot-scope="scope">
          <div>
            <div>总人数:{{ scope.row.totalNum }}</div>
            <div>任务完成:{{ scope.row.completeNum + scope.row.successNum }}</div>
            <div>转化人数:{{ scope.row.successNum }}</div>
          </div>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="ruleSn"
          label="导购筛选"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                class="blue"
                @click="fafang(scope.row)"
                >查看所有发放导购</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="ruleName"
          label="筛选模式"
        >
          <template slot-scope="scope">
            <div class="flex flex-center" v-if="scope.row.model === 'peoplePackage'">
              选择会员人群
            </div>
            <div class="flex flex-center" v-else-if="scope.row.model === 'manual'">
              手动筛选
            </div>
            <div class="flex flex-center" v-else-if="scope.row.model === 'tagGroup'">
              自建人群
            </div>
            <div class="flex flex-center" v-else>
              自动筛选
              <!-- <el-button
                size="small"
                type="text"
                class="blue"
                @click="screening(scope.row)"
                >自动筛选</el-button
              > -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="showCountList(scope.row)"
                >导购完成统计</el-button
              >
              <el-button size="small" type="text" @click="toActivityTaskList(scope.row)"
                >任务会员明细</el-button
              >
            </div>
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button size="small" type="text" @click="del(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="dialogVisible"
    >
      <div v-if="tab === 'ziding'">
        <ul class="fafang">
          <li style="margin-Bottom:40px">
            <div class="title">
              会员基础信息
            </div>
            <div class="flex flex-center ml20">
              <div class="flex-1">
                <span class="gray">会员情况：</span> 12312
              </div>
              <div class="flex-1">
                <span class="gray"> 宝宝性别： </span>12312
              </div>
              <div class="flex-1">
                <span class="gray"> 宝宝年龄段： </span>12312
              </div>
            </div>
            <div class="flex flex-center ml20 mt10">
              <div class="flex-1">
                <span class="gray">
                  消费能力：
                </span>
                12312
              </div>
              <div class="flex-1">
                <span class="gray"> 客户活跃度： </span>12312
              </div>
              <div class="flex-1"></div>
            </div>
          </li>
          <li class="mb20">
            <div class="title">
              会员消费信息
            </div>
            <div class="flex flex-center ml20">
              <div class="flex-1">
                <span class="gray">
                  品类筛选：
                </span>
                12312
              </div>
              <div class="flex-1">
                <span class="gray"> 品牌筛选： </span>12312
              </div>
              <div class="flex-1">
                <span class="gray"> 商品货号： </span>12312
              </div>
            </div>
            <div class="flex flex-center ml20 mt10">
              <div class="flex-1">
                <span class="gray">
                  商城会员筛选：
                </span>
                12312
              </div>
              <div class="flex-1">
                <span class="gray"> 购买时间筛选： </span>12312
              </div>
              <div class="flex-1"></div>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="tab === 'daogou'">
        <!-- <div class="flex flex-center" style="margin-bottom:100px;">
          <div class="flex-1"><span class="gray">会员情况：</span> 12312</div>
          <div class="flex-1"><span class="gray"> 宝宝性别： </span>12312</div>
          <div class="flex-1">
            <span class="gray"> 宝宝年龄段： </span>12312
          </div>
        </div> -->
        <el-table
          stripe
          border
          ref="guiderTable"
          :data="guiderList"
          style="width: 100%"
          size="small"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderName"
            label="导购姓名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="departName"
            label="导购机构"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderPhone"
            label="导购手机"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-center mt10">
        <el-button size="small" type="primary" @click="dialogVisible = false"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="导购完成进度"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
      :visible.sync="countDialogVisible"
    >
    <div class="count">
      <div class="flex flex-between item-center mb20">
        <div class="flex">
          <div class="mr20">总人数：{{ currentRow.totalNum }}</div>
          <div class="mr20">联系人数：{{ currentRow.completeNum + currentRow.successNum }}</div>
          <div class="mr20">转化人数：{{ currentRow.successNum }}</div>
        </div>
        <el-button type="primary" size="small" @click="output('showCountListAll', '导购完成进度')">下载明细</el-button>
      </div>
      <el-table
          stripe
          border
          ref="countList"
          :data="countList"
          style="width: 100%"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPageCount - 1) * pageSizeCount + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realName"
            label="导购姓名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="departName"
            label="导购机构"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="phone"
            label="导购手机"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="totalNum"
            label="分配人数"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="completeNum"
            label="任务完成人数"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="successNum"
            label="转化人数"
          >
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalCount"
            @current-change="pagingCount"
            @size-change="handleSizeChangeCount"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPageCount"
          ></el-pagination>
        </div>
    </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      searchCondition: {
        status: "all"
      },
      list: [],
      guiderList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      isOutputing: false,
      dialogVisible: false,
      title: "",
      tab: "",
      ingNum: 0,
      outNum: 0,
      countDialogVisible: false,
      currentRow: {},
      countList: [],
      currentPageCount: 1,
      pageSizeCount: 10,
      totalCount: 0,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    add() {
      this.$router.push({
        name: "AddShoppersTask"
      });
    },

    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.status =
        searchCondition.status === "all" ? "" : searchCondition.status;
      searchCondition.startDate =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.endDate =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryGuiderTaskList",
        params
      );
      const { ingNum, outNum } = result;
      const { records, total } = result.taskList;
      this.ingNum = ingNum;
      this.outNum = outNum;
      this.list = records;
      this.total = total;
    },
    // queryAllList() {
    //   let params = {
    //     pageNo: 1,
    //     pageSize: 99999
    //   };
    //   const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
    //   searchCondition.status =
    //     searchCondition.status === "all" ? "" : searchCondition.status;
    //   searchCondition.createTimeStart =
    //     this.searchCondition.createTimeArry &&
    //     this.searchCondition.createTimeArry.length > 0
    //       ? this.searchCondition.createTimeArry[0]
    //       : null;
    //   searchCondition.createTimeEnd =
    //     this.searchCondition.createTimeArry &&
    //     this.searchCondition.createTimeArry.length > 0
    //       ? this.searchCondition.createTimeArry[1]
    //       : null;
    //   Object.assign(params, searchCondition);
    //   const { result } = await this.$store.dispatch(
    //     "queryGuiderTaskList",
    //     params
    //   );
    //   const { ingNum, outNum } = result;
    //   const { records, total } = result.taskList;
    //   this.ingNum = ingNum;
    //   this.outNum = outNum;
    //   this.list = records;
    //   this.total = total;
    // },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    edit(row) {
      this.$router.push({
        name: "EditShoppersTask",
        query: {
          taskId: row.taskId
        }
      });
    },
    del(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("delGuiderTask", { taskId: row.taskId })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    fafang(row) {
      this.dialogVisible = true;
      this.tab = "daogou";
      this.title = "导购筛选";
      this.$store.dispatch("findGuiderList", row).then(res => {
        this.guiderList = res.result;
      });
    },
    screening() {
      this.dialogVisible = true;
      this.tab = "ziding";
      this.title = "自动筛选";
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res.result.records;
            const tHeader = this.$refs.countList.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.countList.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    toActivityTaskList(row){
      this.$router.push({
        name: "ActivityTaskList",
        query: {
          queryType: 'taskName',
          taskName: row.taskName
        }
      });
    },
    async showCountList(row){
      if(row){
        this.currentRow = row;
      }
      let params = {
        pageNo: this.currentPageCount,
        pageSize: this.pageSizeCount,
        taskId: this.currentRow.taskId,
      };
      const { result } = await this.$store.dispatch("queryGuiderSummary", params);
      const { records, total } = result;
      this.countList = records;
      this.totalCount = total;
      this.countDialogVisible = true;
    },
    showCountListAll(){
      let params = {
        pageNo: 1,
        pageSize: 99999,
        taskId: this.currentRow.taskId,
      };
      return this.$store.dispatch("queryGuiderSummary", params);
    },
    pagingCount(page) {
      this.currentPageCount = page;
      this.showCountList();
    },
    handleSizeChangeCount(size) {
      this.currentPageCount = 1;
      this.pageSizeCount = size;
      this.showCountList();
    },
  }
};
</script>
<style lang="scss" scoped>
.fafang {
  .title {
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
</style>
